import { useEffect, useState } from "react";
import SessionsApi from "../../../../../../api/sessionApi";
import ConfirmationModal from "../../../../../../components/ConfirmationModal/ConfirmationModal";
import ModalWindow from "../../../../../../components/ModalWindow/ModalWindow";
import TripleDotPoperMenu from "../../../../../../components/TripleDotPoperMenu/TripleDotPoperMenu";
import { SessionPackage } from "../../../../../../types/TypeSession";
import { SuccesNotify } from "../../../../../../utils/toaster";
import PackageCard from "../../../../../SessionPackages/PackageCard/PackageCard";
import PackagesTool from "./PackagesTool/PackagesTool";
import s from "./ProjectPackage.module.css";

type ProjectPackageProps = {
  specialization: {
    mainSpecializationRef: string;
    specialization: string;
  };
  projectId: string;
  staticPackages: SessionPackage[];
};

const ProjectPackage = ({
  specialization,
  projectId,
  staticPackages,
}: ProjectPackageProps) => {
  const token = localStorage.getItem("token");
  const [createPackageModal, setCreatePackageModal] = useState(false);
  const [packageData, setPackageData] = useState<SessionPackage | undefined>();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  useEffect(() => {
    if (
      !staticPackages.length ||
      !staticPackages.every((el) => el.specializations)
    )
      return;
    const currentPackage = staticPackages.find(
      (el) =>
        el.specializations![0].mainSpecializationRef ===
        specialization.mainSpecializationRef
    );

    setPackageData(currentPackage);
  }, [staticPackages]);

  const deletePackage = async () => {
    if (!token || !packageData) return;
    const response = await SessionsApi.deletePackage(token, packageData._id);
    if (response.status) {
      SuccesNotify("Package has been deleted");
      setConfirmDeleteModal(false);
      setPackageData(undefined);
    }
  };

  const menuItems = [
    { title: "Update", action: () => setCreatePackageModal(true) },
    {
      title: "Delete",
      action: () => setConfirmDeleteModal(true),
      styles: { color: "red" },
    },
  ];

  return (
    <div className={s.container}>
      <div className={s.head}>
        <span className={s.title}>{specialization.specialization} Package</span>
        {packageData && <TripleDotPoperMenu menuItemDta={menuItems} />}
      </div>
      {packageData ? (
        <PackageCard sessionPackage={packageData} isStaticProjectPackage />
      ) : (
        <div
          className={s.addPackageBtn}
          onClick={() => setCreatePackageModal(true)}
        >
          +
        </div>
      )}
      <ModalWindow
        isOpen={createPackageModal}
        setIsOpen={setCreatePackageModal}
        width="fit-content"
      >
        <PackagesTool
          specialization={specialization.specialization}
          setPackageData={setPackageData}
          setCreatePackageModal={setCreatePackageModal}
          projectId={projectId}
          packageId={packageData?._id}
        />
      </ModalWindow>
      <ConfirmationModal
        confirmFunc={deletePackage}
        confirmTitle="Are you sure you want to delete this session package?"
        modalVisible={confirmDeleteModal}
        setModalVisible={setConfirmDeleteModal}
      />
    </div>
  );
};

export default ProjectPackage;
